'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';

const PHONE = '9492935721';
const SMS_LINK = `sms:${PHONE}`;

const galleryImages = [
  {
    src: 'https://da1mambadetailing.com/assets/64745EE9-DA2F-493A-B030-5BB30C3F9EA9_1751754690948.jpg',
    alt: 'Pristine Lamborghini after professional detailing service by DA1MAMBA',
    span: 'col-span-2 row-span-2',
  },
  {
    src: 'https://da1mambadetailing.com/assets/IMG_0296_1751754717613.jpg',
    alt: 'BMW M5 and Rolls-Royce fleet service by DA1MAMBA Professional Detailing',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://da1mambadetailing.com/assets/314609221_166020389450136_2725712082903081790_n_1751758475934.jpg',
    alt: 'Professional Rolls Royce luxury detailing service by DA1MAMBA',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://da1mambadetailing.com/assets/97126918-EC29-40BB-B6B4-2F58B077FB33_1751754684931.jpg',
    alt: 'Tesla premium foam wash treatment at golden hour by DA1MAMBA',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://da1mambadetailing.com/assets/280216952_1462596080837580_1062062813163839722_n_1751758262081.jpg',
    alt: 'Lamborghini with flawless paint correction results by DA1MAMBA',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://da1mambadetailing.com/assets/image0_1751736526771.jpeg',
    alt: 'Luxury Rolls-Royce dashboard detailing by DA1MAMBA Professional Detailing',
    span: 'col-span-1 row-span-1',
  },
];

export default function GalleryPreview() {
  const [lightbox, setLightbox] = useState<string | null>(null);

  return (
    <section style={{ padding: '120px 0', background: 'var(--mamba-black)' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="label-gold mb-4 reveal">
              <span style={{ width: '32px', height: '1px', background: 'var(--mamba-gold-light)', display: 'inline-block' }} />
              Our Work
            </div>
            <h2
              className="section-heading reveal reveal-delay-1"
              style={{ fontSize: 'clamp(30px, 3.5vw, 48px)' }}
            >
              The work speaks<br />
              <span
                style={{
                  background: 'linear-gradient(135deg, var(--mamba-purple-bright), var(--mamba-gold-light))',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                for itself.
              </span>
            </h2>
          </div>
          <div className="reveal reveal-delay-2 flex flex-col gap-3 items-start md:items-end">
            <p style={{ color: 'var(--gray-dim)', fontSize: '14px', fontFamily: 'DM Sans, sans-serif', maxWidth: '260px', lineHeight: '1.6', textAlign: 'right' }}>
              Real results from real clients across Newport Beach, Irvine, and Orange County. No filters, no staging.
            </p>
            <div className="flex gap-3">
              <a href={SMS_LINK} className="btn-primary" style={{ fontSize: '12px', padding: '12px 22px' }}>
                Text for a Quote
              </a>
              <Link href="/gallery" className="btn-ghost" style={{ fontSize: '12px', padding: '12px 22px' }}>
                Full Gallery →
              </Link>
            </div>
          </div>
        </div>

        {/* Bento grid */}
        <div className="hidden md:grid grid-cols-3 grid-rows-3 gap-2 reveal" style={{ height: 'clamp(400px, 60vw, 700px)' }}>
          {galleryImages?.map((img, i) => (
            <div
              key={i}
              className={`gallery-item ${img?.span}`}
              onClick={() => setLightbox(img?.src)}
              style={{ borderRadius: '2px', overflow: 'hidden', position: 'relative', cursor: 'pointer' }}
            >
              <Image
                src={img?.src}
                alt={img?.alt}
                fill
                className="object-cover"
                sizes="(max-width: 768px) 100vw, 50vw"
              />
              <div className="gallery-overlay" />
            </div>
          ))}
        </div>

        {/* Mobile grid */}
        <div className="md:hidden grid grid-cols-2 gap-2 reveal">
          {galleryImages?.slice(0, 4)?.map((img, i) => (
            <div
              key={i}
              onClick={() => setLightbox(img?.src)}
              style={{ aspectRatio: '4/3', borderRadius: '2px', overflow: 'hidden', position: 'relative', cursor: 'pointer' }}
            >
              <Image
                src={img?.src}
                alt={img?.alt}
                fill
                className="object-cover"
                sizes="50vw"
              />
              <div className="gallery-overlay" />
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-8 reveal">
          <Link href="/gallery" className="btn-ghost" style={{ fontSize: '13px', padding: '14px 32px' }}>
            View Full Gallery →
          </Link>
        </div>
      </div>
      {/* Lightbox */}
      {lightbox && (
        <div
          className="lightbox-overlay"
          onClick={() => setLightbox(null)}
        >
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-6 right-6 z-10"
            style={{ color: 'white', background: 'rgba(107,33,168,0.3)', border: '1px solid rgba(107,33,168,0.5)', padding: '10px', borderRadius: '2px' }}
            aria-label="Close lightbox"
          >
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <div
            className="relative"
            style={{ maxWidth: '90vw', maxHeight: '85vh', width: '100%', height: '100%' }}
            onClick={(e) => e?.stopPropagation()}
          >
            <Image
              src={lightbox}
              alt="DA1MAMBA detailing work"
              fill
              className="object-contain"
              sizes="90vw"
            />
          </div>
        </div>
      )}
    </section>
  );
}
